module.exports = __webpack_public_path__ + "img/impps.1169c36f.jpg";